<script lang="ts">
	import Tooltip_v5 from '$lib/atoms/Tooltip_v5.svelte'
	import IconWarning from '$svg/icon-warning.svg?component'
	import { DangerKind, TooltipPlacements } from '$types/enums'
	import { t } from '$i18n/i18n'

	interface Props {
		/** every reason this value makes the material dangerous, the icon is hidden when empty */
		kinds: DangerKind[]
		placement?: TooltipPlacements
	}

	let { kinds, placement = TooltipPlacements.RIGHT }: Props = $props()

	const isRange = $derived(kinds.includes(DangerKind.RANGE))
	const isEcotoxic = $derived(kinds.includes(DangerKind.ECOTOXIC))

	// listed in the order the title names them
	const reason = $derived.by(() => {
		if (isRange && isEcotoxic) {
			return $t('Analytics.danger.both.tooltip')
		} else if (isRange) {
			return $t('Analytics.danger.range.tooltip')
		}
		return $t('Analytics.danger.ecotoxic.tooltip')
	})
</script>

{#if kinds.length}
	<Tooltip_v5 placementTtip={placement} appendToObject="parent">
		<div class="danger-icon">
			<IconWarning width="18" height="18" />
		</div>
		{#snippet content()}
			<div class="danger-tooltip">
				<span class="danger-tooltip-title">{$t('Analytics.danger.title')}</span>
				<span>{reason}</span>
			</div>
		{/snippet}
	</Tooltip_v5>
{/if}

<style>
	.danger-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: none;
		width: 2rem;
		height: 2rem;
		border-radius: 50%;
		background-color: var(--color-highlight-red-200);
		color: var(--color-highlight-red-800);
	}

	/* a triangle carries its mass below the bounding box centre, so it needs a nudge to look centred */
	.danger-icon :global(svg) {
		transform: translateY(-1px);
	}

	.danger-tooltip {
		display: flex;
		flex-direction: column;
		gap: 4px;
		width: 100%;
		text-align: left;
	}

	.danger-tooltip-title {
		font-weight: 500;
	}
</style>
